import React from 'react';
import { LuRefreshCw } from 'react-icons/lu';
import { fields } from '../../constants/documentConfig';

const ApplicationInfo = ({ applicationInfo, isExtracting, shouldShowRefresh, onChange, onRefresh }) => {
  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '16px' }}>
        <span style={{ fontSize: '12px', color: '#6B7FA8' }}>
          Application details — auto-filled when you extract from a job description
        </span>
        {shouldShowRefresh && (
          <button
            type="button"
            onClick={onRefresh}
            disabled={isExtracting}
            className="refresh-btn"
            title="Extract from job description"
          >
            <LuRefreshCw
              style={{ width: '14px', height: '14px' }}
              className={isExtracting ? 'animate-spin' : ''}
            />
          </button>
        )}
      </div>

      {isExtracting && (
        <div className="extracting-notice">
          Extracting information from job description...
        </div>
      )}

      <div className="app-info-grid">
        {fields.map((field) => {
          const value = applicationInfo[field.key] || '';
          const showCounter = field.maxLength && value.length >= field.maxLength * 0.9;
          return (
            <div key={field.key}>
              <label className="field-label">{field.label}</label>
              <input
                type="text"
                className="input"
                value={value}
                onChange={(e) => onChange(field.key, e.target.value)}
                placeholder={field.placeholder || `Enter ${field.label.toLowerCase()}`}
                maxLength={field.maxLength}
              />
              {showCounter && (
                <div className="field-char-count">
                  {value.length.toLocaleString()} / {field.maxLength.toLocaleString()}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ApplicationInfo;
